export function getAvatarText(name?: string) {
  return `${name?.[0] || ''}${name?.[1] || ''}`.toUpperCase()
}
